export const queryKey = {
  getConfigurationJsonContent:
    "PRODUCT_CONFIGURATION_GETCONFIGURATION_JSON_CONTENT",
  getProductSetupList: "PRODUCT_CONFIGURATION_GET_PRODUCT_STEUP_LIST",
  getCategorySetupList: "PRODUCT_CONFIGURATION_GET_CATEGORY_SETUP_LIST",
  getConfigOptionList: "PRODUCT_CONFIGURATION_GET_CONFIG_OPTION_LIST",
  getAllConfigOptions: "PRODUCT_CONFIGURATION_GET_ALL_CONFIG_OPTIONS",
  getValidationRuleList: "PRODUCT_CONFIGURATION_GET_VALIDATION_RULE_LIST",
  getConfigVersions: "PRODUCT_CONFIGURATION_GET_CONFIG_VERSIONS",
};